import * as React from 'react'
import {Card} from 'material-ui'
import creiosTheme from '../Theme/creiosTheme'
import CardTitle from 'material-ui/Card/CardTitle'
import injectSheet from 'react-jss'
import {WithClasses} from './Helper'

const logo = require('../img/cis-logo.png')

const styles = {
    login: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        maxHeight: '900px',
        padding: '80px',
        boxSizing: 'border-box'
    },
    loginContent: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
    },
    loginInput: {
        textAlign: 'center',
    },
    loginLogo: {
        display: 'flex',
        flexGrow: '1',
        justifyContent: 'center',
        msFlexOrder: '1',
        order: '1',
        alignItems: 'center',
        margin: '40px 80px',
    },
    loginCard: {
        flexGrow: '1',
        order: '2',
        width: 'auto',
        padding: '16px'
    },
    copyright: {
        textAlign: 'right',
        fontSize: '14px'
    },
    copyrightLink: {
        textDecoration: 'none'
    },

}

interface Properties {
    readonly children: React.ReactNode
}

export const PublicPage =
    injectSheet<Properties>(styles)(
        ({classes, children}: WithClasses<Properties>) => (
            <div className={classes.login}>
                <div>
                    <div className={classes.loginContent}>
                        <div className={classes.loginLogo}>
                            <img className="login__logo-img" src={logo}/>
                        </div>
                        <Card className={classes.loginCard}>
                            <CardTitle
                                title="Central Information System"
                                titleColor={creiosTheme.palette.primary1Color}
                            />
                            {children}
                        </Card>
                    </div>
                    <div className="login__footer">
                        <p className={classes.copyright}>
                            <a
                                href="https://creios.net"
                                style={{color: creiosTheme.palette.primary1Color}}
                                className={classes.copyrightLink}
                            >
                                © creios GmbH 2018
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        )
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/PublicPage.tsx